export default __webpack_public_path__ + "static/media/locked.d30d1709.svg";